/**
 * @file 家长推荐轮播
 * @author 陈恩浩
 */

import React, { Component } from 'react'
import Swiper from 'swiper'

import 'src/static/swiper/swiper.css'
import './index.scss'

class Teachers extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    new Swiper('.swiper-container-parent', {
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next-parent-t',
        prevEl: '.swiper-button-prev-parent-t',
      },
      loop: true,
      loopedSlides: 10,
      // autoplay: true,
    })
  }

  render() {
    let parentList = [
      { url: '//cdn.ihatoo.com/hatu-official/teacher/video/v1.mp4' },
      { url: '//cdn.ihatoo.com/hatu-official/teacher/video/v2.mp4' },
      { url: '//cdn.ihatoo.com/hatu-official/teacher/video/v3.mp4' },
      { url: '//cdn.ihatoo.com/hatu-official/teacher/video/v4.mp4' },
      { url: '//cdn.ihatoo.com/hatu-official/teacher/video/v5.mp4' }
    ]
    return (
      <div className="parent-swiper">
        <div className="swiper-container swiper-container-parent">
          {/* <!-- Additional required wrapper --> */}
          <div className="swiper-wrapper">
            {/* <!-- Slides --> */}
            {parentList.map((item, index) => (
              <video className="video" controls key={'parentSwiperList-' + index}
                className="swiper-slide">
                <source src={item.url} type="video/mp4" />
              </video>
            ))}
          </div>
          {/* <!-- If we need navigation buttons --> */}
          <div className="swiper-button-next-parent-t"></div>
          <div className="swiper-button-prev-parent-t"></div>
        </div>
      </div>
    )
  }
}

export default Teachers
